import { Menu } from '@headlessui/react';
import { Button } from '../../components/Button';
import { ChevronDownIcon, Cog6ToothIcon } from '@heroicons/react/24/outline';

interface EditTripSettingsMenuProps {
  onOpenDetails: () => void;
  onOpenSharing: () => void;
}

/**
 * Presentational component for the settings dropdown menu.
 * Shows options for Trip Details and Privacy & Sharing.
 */
export const EditTripSettingsMenu = ({
  onOpenDetails,
  onOpenSharing,
}: EditTripSettingsMenuProps) => {
  return (
    <Menu as="div" className="absolute top-4 right-4 z-30">
      <Menu.Button
        as={Button}
        variant="secondary"
        size="sm"
        iconBefore={<Cog6ToothIcon className="h-5 w-5" />}
        iconAfter={<ChevronDownIcon className="h-4 w-4" />}
      >
        Settings
      </Menu.Button>

      <Menu.Items
        className="absolute right-0 mt-2 w-48 origin-top-right rounded-lg bg-surface shadow-xl
          ring-1 ring-black ring-opacity-5 focus:outline-none overflow-hidden"
      >
        <div className="py-1">
          <Menu.Item>
            {() => (
              <Button
                variant="ghost"
                size="sm"
                onClick={onOpenDetails}
                className={`w-full justify-start rounded-none px-3`}
              >
                Trip Details
              </Button>
            )}
          </Menu.Item>
          <Menu.Item>
            {() => (
              <Button
                variant="ghost"
                size="sm"
                onClick={onOpenSharing}
                className={`w-full justify-start rounded-none px-3`}
              >
                Privacy & Sharing
              </Button>
            )}
          </Menu.Item>
        </div>
      </Menu.Items>
    </Menu>
  );
};
